import React from 'react'

import { Row, Col, Form, FormGroup, Input, Label, Button } from 'reactstrap'

import { EmailsApi } from 'typescript-axios'
import GuruModal from './GuruModal'
import * as fbq from '../lib/fpixel'

import useTranslation from '../hooks/UseTranslation'
import { getAxiosParams } from '../utils/client'
import { UserContext } from '../contexts/UserContext'

const EMAILS_SERVICE = new EmailsApi(getAxiosParams())

const ContactForm = (props) => {
  const { t } = useTranslation()
  const { loggedUser } = React.useContext(UserContext)
  const [firstname, setFirstname] = React.useState(loggedUser?.firstname)
  const [lastname, setLastname] = React.useState(loggedUser?.lastname)
  const [email, setEmail] = React.useState(loggedUser?.email)
  const [msg, setMsg] = React.useState('')
  const [isLoading, setIsLoading] = React.useState(false)
  const [showModal, setShowModal] = React.useState(false)

  const onSubmit = async (e) => {
    setIsLoading(true)
    e.preventDefault()
    await EMAILS_SERVICE.sendContactEmailApiV1EmailsContactPost(
      firstname,
      lastname,
      email,
      msg
    )
    fbq.event('Contact')
    setIsLoading(false)
    if (props.onSubmitted) {
      props.onSubmitted()
    } else {
      setShowModal(true)
    }
  }

  return (
    <div>
      <GuruModal
        isOpen={showModal}
        toggle={() => {
          setShowModal(false)
        }}
        title={t('contact_modal_success_title')}
      >
        {t('contact_modal_success')}
      </GuruModal>
      <Form onSubmit={onSubmit}>
        <div className='controls'>
          <Row>
            <Col sm='6'>
              <FormGroup>
                <Label for='firstname' className='form-label'>
                  {props.firstname_label ?? t('contact_form_firstname_label')}
                </Label>
                <Input
                  type='text'
                  name='firstname'
                  id='firstname'
                  value={firstname}
                  disabled={loggedUser}
                  onChange={(e) => setFirstname(e.target.value)}
                  placeholder={t('contact_form_firstname_placeholder')}
                  required
                />
              </FormGroup>
            </Col>
            <Col sm='6'>
              <FormGroup>
                <Label for='lastname' className='form-label'>
                  {props.lastname_label ?? t('contact_form_lastname_label')}
                </Label>
                <Input
                  type='text'
                  name='lastname'
                  id='lastname'
                  value={lastname}
                  disabled={loggedUser}
                  onChange={(e) => setLastname(e.target.value)}
                  placeholder={t('contact_form_lastname_placeholder')}
                  required
                />
              </FormGroup>
            </Col>
          </Row>
          <FormGroup>
            <Label for='email' className='form-label'>
              {props.email_label ?? t('contact_form_email_label')}
            </Label>
            <Input
              type='email'
              name='email'
              id='email'
              value={email}
              disabled={loggedUser}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={t('contact_form_email_placeholder')}
              required
            />
          </FormGroup>
          <FormGroup>
            <Label for='message' className='form-label'>
              {t('contact_form_message_label')}
            </Label>
            <Input
              type='textarea'
              rows='4'
              name='message'
              id='message'
              value={msg}
              onChange={(e) => setMsg(e.target.value)}
              placeholder={
                props.placeholder ?? t('contact_form_message_placeholder')
              }
              required
            />
          </FormGroup>
          <div className={`${props.rightBtn ? 'text-right' : ''}`}>
            <Button type='submit' disabled={isLoading} color='outline-primary'>
              {t('contact_form_send_button')}
            </Button>
          </div>
        </div>
      </Form>
    </div>
  )
}

export default ContactForm
